import { render, staticRenderFns } from "./Careerbak.vue?vue&type=template&id=5a036fee&scoped=true"
import script from "./Careerbak.vue?vue&type=script&lang=js"
export * from "./Careerbak.vue?vue&type=script&lang=js"
import style0 from "./Careerbak.vue?vue&type=style&index=0&id=5a036fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a036fee",
  null
  
)

export default component.exports